import { WebApiName } from './web-api-name.enum';

export interface WindowWithPermissionService extends Window {
    DWSPermissionsServiceInstance: PermissionsApiService;
}

export class PermissionsApiService {

    /**
     * Get PermissionsApiService instance
     */
    public static getInstance(): PermissionsApiService | undefined {
        const windowInstance = this.getGlobalInstance();

        if (windowInstance) {
            return windowInstance;
        }

        if (!this.instance) {
            try {
                this.instance = new PermissionsApiService();
                (window as WindowWithPermissionService & typeof globalThis).DWSPermissionsServiceInstance = this.instance;
            } catch (e) {
                console.info((<Error> e).message);
                return undefined;
            }
        }

        return this.instance;
    }

    private static instance: PermissionsApiService;

    /**
     * Retrieve instance from Window DOM interface
     */
    private static getGlobalInstance(): PermissionsApiService | undefined {
        const win: WindowWithPermissionService = window as WindowWithPermissionService & typeof globalThis;

        if (!win) {
            return undefined;
        }

        /* tslint:disable-next-line:no-string-literal */
        if (win['DWSPermissionsServiceInstance'] === undefined) {
            return undefined;
        }

        /* tslint:disable-next-line:no-string-literal */
        return win['DWSPermissionsServiceInstance'];
    }

    /**
     * Service CTOR
     */
    public constructor() {
        if (!(WebApiName.Permissions in (window.navigator as Navigator))) {
            throw new Error('PermissionsAPI not available');
        }
    }

    /**
     * Permissions API query
     */
    public queryFor(permission: WebApiName): Promise<PermissionStatus> {
        return window.navigator.permissions.query({ name: permission as PermissionName });
    }

}
